/**
 * Created by Timur on 27.07.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    BALLOON_RISE: {
        EARN: "balloon_rise",
        STAGE: "balloon_rise_stage_"
    }
});
